var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch4 = function SvgSearch4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#213D38",
    fillOpacity: 0.32,
    d: "m14.802 15.93-.503-.487.975-1.004.503.487zm5.686 3.568.502.487-.975 1.005-.503-.488zM17 17.088l.488-.502zM4.7 10.516c0 3.192 2.673 5.815 6.014 5.815v1.4c-4.075 0-7.414-3.21-7.414-7.215zm6.014 5.815c3.341 0 6.014-2.623 6.014-5.815h1.4c0 4.005-3.34 7.215-7.414 7.215zm6.014-5.815c0-3.192-2.673-5.815-6.014-5.815V3.3c4.075 0 7.414 3.21 7.414 7.215zM10.714 4.7C7.373 4.7 4.7 7.323 4.7 10.515H3.3C3.3 6.511 6.64 3.3 10.714 3.3zm5.063 10.226 1.71 1.66-.974 1.005-1.711-1.66zm1.71 1.66 3 2.912-.974 1.004-3-2.91z"
  })));
};
export default SvgSearch4;